import classNames from 'classnames/bind';
import config from 'config/index';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  id: string;
  name: string;
}

export default function OtaLogo({ id, name }: IProps) {
  return (
    <img
      className={cx('OtaLogo')}
      src={`${config.cdnDomain}/flight/vertical-static/flight/company/${id}.png`}
      alt={name}
    />
  );
}
